<template>
  <a-layout>
    <a-tabs v-model="activeKey" style="margin-top: -4px">
      <a-tab-pane key="1" :tab="$t('tab.disqualificationOrder')" style="margin-top: -14px">
        <disqualification-confirm-table ref="disqualificationConfirmTable" @dblclick="dblclick"/>
      </a-tab-pane>
      <a-tab-pane key="2" :tab="$t('tab.orderDetail')" forceRender style="margin-top: -14px">
        <disqualification-confirm-detail ref="disqualificationConfirmDetail" @failed="failed" @success="success"/>
      </a-tab-pane>
      <a-space slot="tabBarExtraContent">
        <a-button type="primary" @click="query">{{ $t('button.query') }}</a-button>
        <a-button type="primary" @click="reset">{{ $t('button.reset') }}</a-button>
        <a-button :disabled="approveDisabled" :loading="approveLoading" type="primary" @click="approve">{{ $t('button.approve') }}</a-button>
        <a-button :disabled="rejectDisabled" :loading="rejectLoading" type="primary" @click="reject">{{ $t('button.reject') }}</a-button>
      </a-space>
    </a-tabs>
  </a-layout>
</template>

<script>
  import DisqualificationConfirmTable from '@/views/quality_control/disqualification_manage/disqualification_confirm/DisqualificationConfirmTable.vue'
  import DisqualificationConfirmDetail from '@/views/quality_control/disqualification_manage/disqualification_confirm/DisqualificationConfirmDetail.vue'

  export default {
    name: 'DisqualificationConfirm',
    components: {
      DisqualificationConfirmDetail,
      DisqualificationConfirmTable
    },
    data() {
      return {
        activeKey: '1',
        approveLoading: false,
        rejectLoading: false,
        approveDisabled: true,
        rejectDisabled: true
      }
    },
    watch: {
      activeKey: {
        handler(newVal) {
          if (newVal === '1') {
            this.approveDisabled = true
            this.rejectDisabled = true
          } else {
            this.approveDisabled = false
            this.rejectDisabled = false
          }
        }
      }
    },
    methods: {
      dblclick(record) {
        this.activeKey = '2'
        this.$refs.disqualificationConfirmDetail.getData(record)
      },
      approve() {
        this.approveLoading = true
        this.$refs.disqualificationConfirmDetail.approve()
      },
      reject() {
        this.rejectLoading = true
        this.$refs.disqualificationConfirmDetail.reject()
      },
      query() {
        if (this.activeKey === '1') {
          this.$refs.disqualificationConfirmTable.getData()
        } else {
          this.$refs.disqualificationConfirmDetail.getData()
        }
      },
      reset() {
        this.$refs.disqualificationConfirmTable.reset()
        this.$refs.disqualificationConfirmDetail.clear()
      },
      success() {
        this.approveLoading = false
        this.rejectLoading = false
        this.$refs.disqualificationConfirmTable.getData()
        this.$refs.disqualificationConfirmDetail.clear()
      },
      failed() {
        this.approveLoading = false
        this.rejectLoading = false
      }
    }
  }
</script>
